export default {
  titles: {
    main: 'Wir können keine weiteren Online-Bestellungen annehmen.',
    opens_today: 'Online Bestellungen sind momentan pausiert. Du kannst wieder online bestellen ab {{time}}.',
    opens_other_day: 'Online Bestellungen sind momentan pausiert. Du kannst wieder online bestellen ab {{dateTime}}.'
  },
  pay_remaining: 'Bitte bezahle die Restrechnung hier.',
  description: 'Online-Bestellungen sind derzeit nicht möglich. Bitte wende dich an das Personal, wenn du Fragen hast.',
};